module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text/6-984561d738f9613d7e132ba9b48a9760.jpg";